const dealerTools = {
  methods: {
    default: (value, options = {}, tags = []) => {
      return value;
    }
  },
  register: function register(key, method) {
    this.methods[key] = method;
  },
  get: function get(key = 'default') {
    return this.methods[key] ?? this.methods.default;
  }
};

export default dealerTools;
